import {REFUND_REQUESTS_REQUEST, REFUND_REQUESTS_RESPONSE} from '../actions/refundRequest.actions';

export default function refundRequest(state = {refundRequests: []}, action) {
  switch (action.type) {
    case REFUND_REQUESTS_REQUEST: {
      let nextState = {...state};
      return nextState;
    }
    case REFUND_REQUESTS_RESPONSE: {
      let nextState = {...state};
      nextState.refundRequests = action.refundRequests;
      return nextState;
    }
  }
  return state;
}
